import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React  from 'react';
import ReactDOM from 'react-dom';
import './setupIcons';
import App from './components/App';
//import auth from 'src/services/auth';
import { initPTag, loadPendoTag } from 'src/utils/pendoTag';
import "./styles/index.less";
//import UserContex from './services/UserContex';

loadPendoTag(initPTag);
//const skinNameLocal =  auth.getSkin();
//const skinName = skinNameLocal === undefined || skinNameLocal === null || skinNameLocal === "ql2" || skinNameLocal === "qdash" ? "standard" : skinNameLocal;


// document.documentElement.setAttribute("data-theme", skinName);

// const favicon:any = document.getElementById('favicon');
// if(skinName == "standard" ||  skinName == "dark mode" ){
//     favicon.href = "/favicon.ico";
// }else{
//     favicon.href = `/${skinName}.ico`;
// }

// window.localStorage.setItem('_TOKEN', 'ETpQX5wcc1');

ReactDOM.render(<App />, document.getElementById('root'));
